import { Person } from '@/models/Person';
import { User } from '@/models/User';
import { AxiosError } from 'axios';
import { AppOrganization } from '../appOrganization/types';

export enum IdentityTypes {
    AUTH_REQUEST = '@identity/AUTH_REQUEST',
    AUTH_SUCCESS = '@identity/AUTH_SUCCESS',
    AUTH_FAILURE = '@identity/AUTH_FAILURE',
    AUTH_FAILURE_CLEAR = '@identity/AUTH_FAILURE_CLEAR',
    FORGOT_PASSWORD_REQUEST = '@identity/FORGOT_PASSWORD_REQUEST',
    FORGOT_PASSWORD_SUCCESS = '@identity/FORGOT_PASSWORD_SUCCESS',
    FORGOT_PASSWORD_FAILURE = '@identity/FORGOT_PASSWORD_FAILURE',
    ACCEPT_TERMS_REQUEST = '@identity/ACCEPT_TERMS_REQUEST',
    ACCEPT_TERMS_SUCCESS = '@identity/ACCEPT_TERMS_SUCCESS',
    ACCEPT_TERMS_FAILURE = '@identity/ACCEPT_TERMS_FAILURE',
    FORGOT_PASSWORD_FAILURE_CLEAR = '@identity/FORGOT_PASSWORD_FAILURE_CLEAR',
    CHANGE_PASSWORD_REQUEST = '@identity/CHANGE_PASSWORD_REQUEST',
    CHANGE_PASSWORD_SUCCESS = '@identity/CHANGE_PASSWORD_SUCCESS',
    CHANGE_PASSWORD_FAILURE = '@identity/CHANGE_PASSWORD_FAILURE',
    CHANGE_PASSWORD_CLEAR = '@identity/CHANGE_PASSWORD_CLEAR',
    AUTH_CLEAR = '@identity/AUTH_CLEAR',
    SET_PERSON_DYNAMIC_ATTRIBUTES = '@identity/SET_PERSON_DYNAMIC_ATTRIBUTES',
    UPDATE_PERSON_LOCALE = '@identity/UPDATE_PERSON_LOCALE',
    UPDATE_PERSON_ONBOARDED = '@identity/UPDATE_PERSON_ONBOARDED',
    UPDATE_PERSON_ACHIEVEMENTS_INFO = '@identity/UPDATE_PERSON_ACHIEVEMENTS_INFO',
    AUTH_INTEGRATION_REQUEST = '@identity/AUTH_INTEGRATION_REQUEST',
    AUTH_INTEGRATION_SUCCESS = '@identity/AUTH_INTEGRATION_SUCCESS',
    AUTH_INTEGRATION_FAILURE = '@identity/AUTH_INTEGRATION_FAILURE',
    UPDATE_MY_PERSON = '@identity/UPDATE_MY_PERSON',
    AUTH_SAML_REQUEST = '@identity/AUTH_SAML_REQUEST',
}

export interface Identity {
    appOrganization: AppOrganization;
    applicationId: number;
    deactivationDate: Date;
    orgId: number;
    user: User;
    person: Person;
}

export interface IdentityState {
    data: Identity;
    loading: boolean;
    hasError: boolean;
    error?: AxiosError;
    forgotPasswordMode?: boolean;
    success: boolean;
}
